import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} || Coach Dennis Isiakpona </title>
                    <meta name="description" content="Coach DOI - Author and Project management Coach" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
